import { useContext, useState } from 'react'
import css from "../changePasswordModal/password.module.scss"
import { AuthContext } from "../../../context/auth";
import { Input } from "../../Input";
import { restorePasswordApi, checkEmailExist } from '../../../api';
import { useNavigate } from 'react-router-dom';

export const ChangePasswordRestoreModal = () => {
  const { setChangePasswordRestoreModal, setNotification, setRestoreModal, setIsLoading, isLoading } = useContext(AuthContext)
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')

  const data = (new URL(document.location).searchParams)
  const token = data.get('token')
  const email = data.get('email')

  const restorePassword = () => {
    if (password !== confirmPassword) {
      setNotification({
        type: 'red',
        message: "Passwords doesn't match"
      })
    } else {
      setIsLoading(true)
      if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
        checkEmailExist(email).then((res) => {
          if (res.data?.exists) {
            restorePasswordApi({ email, password, token }).then((res) => {
              setIsLoading(false)
              setNotification({
                type: 'success',
                message: 'Password Successfully Changed!'
              })
              setChangePasswordRestoreModal(false)
            }).catch((err) => {
              setIsLoading(false)
              setNotification({
                type: 'red',
                message: 'Something went wrong, please try again!'
              })
            })
          } else {
            setIsLoading(false)
            setNotification({
              type: 'red',
              message: 'Invalid Reset Password Link!'
            })
            setChangePasswordRestoreModal(false)
            navigate('/')
          }
        }).catch((err) => {
          setIsLoading(false)
          setNotification({
            type: 'red',
            message: 'Something went wrong, please try again!'
          })
        })
      } else {
        setIsLoading(false)
        setNotification({
          type: 'red',
          message: 'Invalid Reset Password Link!'
        })
        setChangePasswordRestoreModal(false)
        navigate('/')
      }
    }
  }


  return (
    <div className={css.modalWrapper}>
      <div className={css.modalContent}>
                <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
        <span className={css.icon}>
          <i class="fal fa-lock"></i>
        </span>
        <span className={css.closeIcon} onClick={() => setChangePasswordRestoreModal(false)}><i className="fas fa-times"></i></span>
        </div>
        <h2>Change Password </h2>
        <div className="form-container" style={{ width: '100%' }}>
          <div style={{ marginTop: '32px' }}>
            <p style={{ marginBottom: '10px', fontSize: '14px', textAlign: 'left' }}>New Password</p>
            <Input type='password' placeholder={"Enter Password"} value={password} onChange={(e) => setPassword(e.target.value)} className={error ? 'error' : ''} />
          </div>
          <div style={{ marginTop: '22px', marginBottom: '22px' }}>
            <p style={{ marginBottom: '10px',fontSize: '14px', textAlign: 'left' }}>Confirm New Password</p>
            <Input type='password' placeholder={"Confirm Password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className={error ? 'error' : ''} />
          </div>
        </div>
        <div className={css.passwordValidations}>
          <span>{password.length >= 8 ? <i className="fas fa-check" style={{ color: '#33C25E', marginRight: '8px' }}></i> : <i className="far fa-circle" style={{ color: '#9a9a9a', marginRight: '8px' }}></i>}At least 8 characters</span>
          <span>{/[A-Z]/.test(password) ? <i className="fas fa-check" style={{ color: '#33C25E', marginRight: '8px' }}></i> : <i className="far fa-circle" style={{ color: '#9a9a9a', marginRight: '8px' }}></i>}At least 1 upper case letter (A-Z).</span>
          <span>{/\d/.test(password) ? <i className="fas fa-check" style={{ color: '#33C25E', marginRight: '8px' }}></i> : <i className="far fa-circle" style={{ color: '#9a9a9a', marginRight: '8px' }}></i>}At least 1 number (0-9).</span>
        </div>
        <button className={`btn ${css.ctaBtn}`}
          disabled={isLoading || !password || !confirmPassword} 
          onClick={() => {
            restorePassword()
          }}>Save</button>
        <button className={`btn ${css.transparentBtn}`} onClick={() => {
          setChangePasswordRestoreModal(false)
          navigate('/')
        }}>Cancel</button>
      </div>
    </div>
  )
}